/* The Hollow Harvest · tracciamento
   Due strumenti in un file solo: il pixel di Meta, che dice alle ads chi
   compra, e Microsoft Clarity, che registra cosa fa davvero chi arriva.

   Quattro regole che questo file rispetta, ed e' il motivo per cui non e'
   copiato dalla documentazione:

   1. NON RALLENTA LA PRIMA SCHERMATA. Le due librerie esterne partono quando
      il browser ha finito di disegnare, non mentre disegna. Fino ad allora le
      chiamate si mettono in coda, quindi non si perde nessun evento e l'LCP
      resta quello misurato (0,48s sul computer, 0,38s sul telefono).
   2. RISPETTA IL CONSENSO. Niente parte senza il si' dato nel banner di
      Shopify: se la risposta di Shopify manca o non arriva, non parte niente
      (dal 27 set 2026; prima partiva tutto, vedi "il consenso" piu' sotto).
      Il pixel dipende dal consenso di marketing, Clarity da quello di
      analisi: sono due cose diverse e vanno chieste separatamente.
   3. SI PUO' SPEGNERE. Aprire il sito con ?hh_internal=1 marca questo
      dispositivo: da quel momento non si carica piu' niente e le visite di
      casa non sporcano i dati. Con ?hh_internal=0 si torna indietro.
   4. NON C'E' NESSUN NUMERO SCRITTO QUI DENTRO. Gli identificativi arrivano
      da snippets/hh-track.liquid, che li legge dalle impostazioni del tema.

   Cosa manda, e quando:
     PageView          ogni pagina, appena la libreria e' pronta
     ViewContent       quando la sezione del prezzo e' stata vista davvero
                       (meta' sezione sullo schermo per un secondo pieno)
     InitiateCheckout  al tocco di un comando che porta al pagamento
     Lead              quando l'iscrizione al registro e' andata a buon fine
   Gli stessi momenti diventano eventi di Clarity, cosi' nella dashboard si
   possono costruire gli imbuti veri. Sui due momenti che contano (pagamento
   e iscrizione) si chiede a Clarity di registrare la sessione per intero.

   L'acquisto NON si traccia da qui: succede sul checkout di Shopify, che non
   esegue il codice del tema. Sta in sito/TRACCIAMENTO.md, pronto da incollare
   negli Eventi cliente del negozio. */

(function () {
  'use strict';

  var C = window.HH_TRACK || {};
  var META = (C.meta || '').replace(/\s/g, '');
  var CLARITY = (C.clarity || '').replace(/\s/g, '');
  if (!META && !CLARITY) return;

  /* ------------------------------------------------ l'interruttore di casa --
     Prima di ogni altra cosa: se questo dispositivo e' segnato come nostro,
     il file finisce qui e non carica niente. */
  var CHIAVE = 'hh_internal';

  function ricorda(dentro) {
    try {
      if (dentro) window.localStorage.setItem(CHIAVE, '1');
      else window.localStorage.removeItem(CHIAVE);
    } catch (e) { /* finestra privata: vale solo per questa visita */ }
  }

  function diCasa() {
    try { return window.localStorage.getItem(CHIAVE) === '1'; } catch (e) { return false; }
  }

  function conferma(testo) {
    if (!testo) return;
    function mostra() {
      var box = document.createElement('div');
      box.setAttribute('role', 'status');
      box.textContent = testo;
      box.style.cssText = 'position:fixed;left:50%;bottom:1.5rem;transform:translateX(-50%);' +
        'z-index:9999;max-width:min(92vw,30rem);padding:.8rem 1.2rem;text-align:center;' +
        'background:var(--soot,#16110C);color:var(--paper,#E8DCC4);' +
        'border:2px solid var(--ember,#C4681F);' +
        'font:500 .95rem/1.4 var(--font-body,Georgia,serif)';
      document.body.appendChild(box);
      /* dieci secondi, non sei: l'avviso compare mentre la pagina sta ancora
         caricando le figure, e chi ha appena aperto il link deve avere il
         tempo di leggerlo. Sei secondi sparivano prima che la pagina fosse
         ferma. */
      setTimeout(function () { box.remove(); }, 10000);
    }
    if (document.body) mostra();
    else document.addEventListener('DOMContentLoaded', mostra, { once: true });
  }

  var chiesto = null;
  try { chiesto = new URLSearchParams(window.location.search).get(CHIAVE); } catch (e) { }

  if (chiesto === '1' || chiesto === '0') {
    ricorda(chiesto === '1');
    /* La conferma si vede SOLO quando il parametro e' stato passato davvero.
       Senza, chi lo usa non sa se ha funzionato: e' gia' successo su un altro sito. */
    conferma(chiesto === '1' ? C.testoSpento : C.testoAcceso);
  }
  if (diCasa()) return;

  /* ------------------------------------------------------------- le code ---
     Le due funzioni esistono da subito e accumulano le chiamate. Le librerie
     vere arrivano dopo e svuotano la coda: nessun evento va perso, e intanto
     la prima schermata si disegna senza concorrenza sulla rete. */
  if (META && !window.fbq) {
    var f = window.fbq = function () {
      if (f.callMethod) f.callMethod.apply(f, arguments);
      else f.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = f;
    f.push = f;
    f.loaded = true;
    f.version = '2.0';
    f.queue = [];
  }
  if (CLARITY && !window.clarity) {
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  }

  /* --------------------------------------------------------- il consenso ---
     (27 set 2026, revisione legale: website/legale/LEGGIMI.md.)
     Fino a oggi questo pezzo lasciava passare tutto quando l'API del consenso
     non c'era, e l'API non c'e' MAI finche' non la si chiede: pixel e Clarity
     partivano a 0,6 s dall'arrivo, prima del banner e anche dopo "Declina".
     Ora e' il contrario: NIENTE parte senza un si' esplicito.
     - L'API si chiede a Shopify con loadFeatures ('consent-tracking-api').
       Se loadFeatures manca, o risponde con un errore, non parte niente.
     - Il pixel di Meta vuole il consenso Marketing (e, negli USA, che la
       persona non abbia chiesto di non vendere/condividere i dati); Clarity
       vuole il consenso Analisi. Dove la legge non chiede il consenso (USA)
       Shopify risponde gia' di si' da solo.
     - Il si' puo' arrivare dopo (banner, preferenze): visitorConsentCollected.
     - Il si' puo' anche essere ritirato dalle preferenze: Clarity cancella i
       suoi cookie (consent false), Meta smette di mandare (consent revoke).
       Dalla pagina dopo, le librerie non si caricano piu'. */
  function privacy() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return p && typeof p.marketingAllowed === 'function' && typeof p.analyticsProcessingAllowed === 'function' ? p : null;
  }

  /* G9 22/10: un si' detto davvero, nel biglietto del tema (hhk.consent, 12 mesi) o gia' dato a Shopify (per esempio
     al checkout). Fuori dalle regioni obbligate marketingAllowed() e analyticsProcessingAllowed() dicono si' senza aver
     chiesto niente, e il biglietto promette che statistiche e pubblicita' partono solo col si'. */
  function sceltaDetta(tipo) {
    try {
      var c = JSON.parse(window.localStorage.getItem('hhk.consent') || 'null');
      if (c && !(c.t && Date.now() / 1000 - c.t > 31536000)) return tipo === 'ads' ? !!c.m : !!c.a;
    } catch (e) { }
    try {
      var v = window.Shopify.customerPrivacy.currentVisitorConsent();
      var x = tipo === 'ads' ? v.marketing : v.analytics;
      if (x === 'yes' || x === 'no') return x === 'yes';
    } catch (e) { }
    /* 23/10, Diego: in Canada fuori dal Quebec (l'admin chiede il consenso solo li') si parte senza aspettare e il
       biglietto avvisa con Rifiuta a un tocco: modello a rinuncia dell'OPC. Rifiuta resta una scelta detta, quindi vince. */
    try {
      var cp = window.Shopify.customerPrivacy;
      if (/^CA/.test(cp.getRegion() || '') && cp.shouldShowBanner() === false) return true;
    } catch (e) { }
    return false;
  }

  function permesso(tipo) {
    try {
      var p = privacy();
      if (!p || !sceltaDetta(tipo)) return false;
      if (tipo === 'ads') {
        var vendita = typeof p.saleOfDataAllowed === 'function' ? p.saleOfDataAllowed() !== false : true;
        return p.marketingAllowed() === true && vendita;
      }
      if (tipo === 'analisi') return p.analyticsProcessingAllowed() === true;
    } catch (e) { }
    return false;
  }

  /* chiede l'API a Shopify una volta sola; cosa() parte solo se c'e' */
  var attese = null;
  function conLaPrivacy(cosa) {
    if (privacy()) { cosa(); return; }
    if (attese) { attese.push(cosa); return; }
    attese = [cosa];
    try {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (errore) {
        if (errore || !privacy()) return;
        var lista = attese;
        attese = [];
        for (var i = 0; i < lista.length; i++) { try { lista[i](); } catch (e) { } }
      });
    } catch (e) { }
  }

  var caricatoMeta = false;
  var caricatoClarity = false;

  function carica(indirizzo) {
    var s = document.createElement('script');
    s.async = true;
    s.src = indirizzo;
    (document.head || document.documentElement).appendChild(s);
  }

  /* Accende quello che il consenso permette. Una libreria si scarica una
     volta sola; se c'era gia' (consenso ritirato e poi ridato nella stessa
     pagina) si riaccende col suo comando. Clarity riceve sempre il segnale
     consentv2 che vuole dal 31 ottobre 2025 per chi arriva dall'UE: analisi
     si' (senza, Clarity non parte affatto), pubblicita' secondo il consenso
     Marketing. */
  function accendi() {
    if (META && permesso('ads')) {
      if (!caricatoMeta) {
        caricatoMeta = true;
        carica('https://connect.facebook.net/en_US/fbevents.js');
      } else {
        try { window.fbq('consent', 'grant'); } catch (e) { }
      }
    }
    if (CLARITY && permesso('analisi')) {
      if (!caricatoClarity) {
        caricatoClarity = true;
        carica('https://www.clarity.ms/tag/' + encodeURIComponent(CLARITY));
      }
      try {
        window.clarity('consentv2', {
          ad_Storage: permesso('ads') ? 'granted' : 'denied',
          analytics_Storage: 'granted'
        });
      } catch (e) { }
    }
  }

  /* Consenso ritirato dalle preferenze a pagina aperta: Clarity cancella i
     suoi cookie e smette (consent false), Meta smette di mandare (revoke).
     Dalla pagina dopo le librerie non si scaricano piu'. */
  function spegni() {
    if (caricatoMeta && !permesso('ads')) {
      try { window.fbq('consent', 'revoke'); } catch (e) { }
    }
    if (caricatoClarity && !permesso('analisi')) {
      try { window.clarity('consent', false); } catch (e) { }
    }
  }

  /* Quando il browser ha un momento libero, e comunque entro un secondo e
     mezzo. Non si aspetta l'evento "load": su questa pagina arriva tardi,
     perche' le figure si caricano man mano che si scorre. */
  function appenaLibero(cosa) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(cosa, { timeout: 1500 });
    else setTimeout(cosa, 500);
  }

  /* ------------------------------------------------------- le chiamate -----
     Tutte difensive: se una libreria non c'e' o e' stata fermata da una
     estensione, il sito non deve accorgersene in nessun modo. */
  function aMeta(nome, dati) {
    if (!META || typeof window.fbq !== 'function') return;
    try { window.fbq('track', nome, dati || {}); } catch (e) { }
  }

  function aClarity(nome) {
    if (!CLARITY || typeof window.clarity !== 'function') return;
    try { window.clarity('event', nome); } catch (e) { }
  }

  function registraTutta(motivo) {
    if (!CLARITY || typeof window.clarity !== 'function') return;
    try { window.clarity('upgrade', motivo); } catch (e) { }
  }

  function etichetta(nome, valore) {
    if (!CLARITY || typeof window.clarity !== 'function' || !valore) return;
    try { window.clarity('set', nome, String(valore).slice(0, 255)); } catch (e) { }
  }

  var merce = {
    content_ids: [C.sku || 'the-hollow-harvest'],
    content_name: C.nome || 'The Hollow Harvest',
    content_type: 'product',
    value: Number(C.valore) || 0,
    currency: C.valuta || 'USD'
  };

  /* Un link che porta al pagamento anche The Hollow Year (assets/hh-dlc.js,
     26 set 2026) ha scritto addosso il valore vero, bundle piu' DLC, e i due
     codici: data-hh-valore e data-hh-ids. Tutti gli altri valgono il bundle,
     come prima. */
  /* La home a due pacchetti (sections/hh-v2.liquid, ottobre 2026) scrive in
     #hhv-dati il nome, la variante e il prezzo di A e di B: un link verso
     /cart/<variante>:1 vale il pacchetto di quella variante, e il prezzo
     visto vale il pacchetto scelto in quel momento. Senza #hhv-dati, tutto
     come prima. */
  var pacchetti = null;
  try {
    var dati = document.getElementById('hhv-dati');
    if (dati) pacchetti = JSON.parse(dati.textContent).track || null;
  } catch (e) { pacchetti = null; }

  function mercePacchetto(k) {
    var p = pacchetti && pacchetti[k];
    if (!p || !(Number(p.v) > 0)) return null;
    return {
      content_ids: [p.id || merce.content_ids[0]],
      content_name: merce.content_name,
      content_type: 'product',
      value: Number(p.v),
      currency: merce.currency
    };
  }

  function pacchettoDi(a) {
    if (!pacchetti || !a) return null;
    var m = /\/cart\/(\d+):/.exec(a.getAttribute('href') || '');
    if (!m) return null;
    for (var k in pacchetti) {
      if (pacchetti.hasOwnProperty(k) && String(pacchetti[k].var) === m[1]) return mercePacchetto(k);
    }
    return null;
  }

  function merceVista() {
    if (!pacchetti) return merce;
    var scelta = document.querySelector('[data-offerta].scelta');
    return mercePacchetto(scelta ? scelta.getAttribute('data-offerta') : 'b') || merce;
  }

  function merceDi(a) {
    var v = a ? Number(a.getAttribute('data-hh-valore')) : 0;
    if (!(v > 0)) return pacchettoDi(a) || merce;
    var ids = (a.getAttribute('data-hh-ids') || '').split(',').filter(function (x) { return x; });
    return {
      content_ids: ids.length ? ids : merce.content_ids,
      content_name: merce.content_name,
      content_type: 'product',
      value: v,
      currency: merce.currency,
      num_items: ids.length || 1
    };
  }

  /* -------------------------------------------------------- da dove viene --
     Le etichette servono a filtrare le registrazioni di Clarity per campagna:
     senza, si guardano mille sessioni per trovare quelle arrivate da un'ad.
     Il tipo di traffico si ricava dai parametri e non dalla pagina che
     rimanda: fbclid regge anche quando il referrer si perde. */
  function provenienza() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var campi = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var pagato = !!(q.get('fbclid') || q.get('gclid') || q.get('ttclid'));
    for (var i = 0; i < campi.length; i++) {
      var v = q.get(campi[i]);
      if (!v) continue;
      etichetta(campi[i], v);
      if (campi[i] === 'utm_medium' && /cpc|paid|ads?/i.test(v)) pagato = true;
    }
    etichetta('traffic_type', pagato ? 'paid' : 'organic');
  }

  /* ----------------------------------------------------------- gli eventi -- */
  var giaVisto = false;

  function vistoIlPrezzo() {
    if (giaVisto) return;
    giaVisto = true;
    aMeta('ViewContent', merceVista());
    aClarity('prezzo_visto');
  }

  function guardaIlPrezzo() {
    /* sulla home a due pacchetti la zona e' il prezzo dell'offerta in
       evidenza: piccola, arriva a meta' schermo anche sul telefono */
    var zona = document.querySelector('.hh-buy') || document.querySelector('[data-hh-prezzo]');
    if (!zona) return;

    /* Senza osservatore (browser vecchi) si manda subito: meglio un evento
       generoso che nessun evento. */
    if (!('IntersectionObserver' in window)) { vistoIlPrezzo(); return; }

    var attesa = null;
    var occhio = new IntersectionObserver(function (voci) {
      voci.forEach(function (voce) {
        if (voce.isIntersecting && voce.intersectionRatio >= 0.5) {
          /* Un secondo pieno sullo schermo: uno scorrimento veloce che
             attraversa la sezione non e' "aver guardato il prezzo". */
          if (!attesa) {
            attesa = setTimeout(function () {
              vistoIlPrezzo();
              occhio.disconnect();
            }, 1000);
          }
        } else if (attesa) {
          clearTimeout(attesa);
          attesa = null;
        }
      });
    }, { threshold: [0, 0.5] });

    occhio.observe(zona);
  }

  /* Il comando che porta al pagamento non ha una classe sola: c'e' quello
     della sezione del prezzo, e ci saranno le scorciatoie. Si riconosce da
     dove porta, non da come si chiama. */
  function versoIlPagamento(nodo) {
    var a = nodo.closest ? nodo.closest('a[href]') : null;
    if (!a) return false;
    var dove = a.getAttribute('href') || '';
    return /\/cart\/|\/checkouts?\//.test(dove);
  }

  function ascoltaIComandi() {
    /* In cattura, cosi' l'evento si registra anche se qualcosa piu' avanti
       ferma la propagazione del tocco. */
    document.addEventListener('click', function (e) {
      var bersaglio = e.target;
      if (!bersaglio || !bersaglio.closest) return;
      if (versoIlPagamento(bersaglio)) {
        /* il tocco che apre la finestra di The Hollow Year non porta ancora
           al pagamento: l'evento parte dopo, una volta sola, dal bottone
           scelto dentro la finestra */
        if (e.hhFinestra) return;
        aMeta('InitiateCheckout', merceDi(bersaglio.closest('a[href]')));
        aClarity('pagamento_iniziato');
        registraTutta('checkout');
        return;
      }
      /* Il regalo scaricato non e' una vendita e non va mescolato agli eventi
         standard di Meta: qui si segna solo su Clarity, che e' dove serve
         sapere quanti di quelli che lasciano l'email aprono davvero il file. */
      if (bersaglio.closest('a[data-hh-regalo]')) {
        aClarity('regalo_scaricato');
      }
    }, true);
  }

  /* L'iscrizione al registro: il modulo ricarica la pagina, quindi il momento
     giusto non e' l'invio ma il ritorno con la conferma gia' disegnata. Si
     segna in sessione perche' un aggiornamento della pagina non conti due. */
  function guardaIlRegistro() {
    if (!document.querySelector('.hh-news__done')) return;
    /* il segno in sessione serve solo a non contare due volte: senza
       consenso non si conta niente, e non si scrive niente */
    if (!permesso('ads') && !permesso('analisi')) return;
    try {
      if (window.sessionStorage.getItem('hh_lead') === '1') return;
      window.sessionStorage.setItem('hh_lead', '1');
    } catch (e) { }
    aMeta('Lead', { content_name: merce.content_name, currency: merce.currency, value: 0 });
    aClarity('iscrizione_fatta');
    registraTutta('lead');
  }

  /* ------------------------------------------------------------- partenza -- */
  if (META) {
    try {
      window.fbq('init', META);
      window.fbq('track', 'PageView');
    } catch (e) { }
  }
  provenienza();

  function pronti() {
    guardaIlPrezzo();
    ascoltaIComandi();
    /* il Lead si conta solo col consenso: prima serve la risposta di Shopify */
    conLaPrivacy(guardaIlRegistro);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pronti, { once: true });
  else pronti();

  appenaLibero(function () { conLaPrivacy(accendi); });

  /* Se il consenso arriva dopo (banner o preferenze), si accende in quel
     momento: le chiamate messe in coda fin qui partono tutte insieme,
     nell'ordine giusto. Se invece viene ritirato, si spegne. */
  document.addEventListener('visitorConsentCollected', function () {
    conLaPrivacy(function () { spegni(); accendi(); });
  });
})();
